// extracted by mini-css-extract-plugin
module.exports = {"HeaderImage":"HeaderImage_HeaderImage__1Tw2_","Background":"HeaderImage_Background__KCiZD","FadeIn":"HeaderImage_FadeIn__2zdpX","fadein":"HeaderImage_fadein__2iu44"};